import { useEffect, useRef, useState } from 'react';

const Layout = ({ children }) => {
  const iframeRef = useRef(null);
  const [iframeVisible, setIframeVisible] = useState(true);

  useEffect(() => {
    
  }, []);

  return (
    <div>
      <div>{children}</div>
      {iframeVisible && (

          <iframe
            ref={iframeRef}
            //src="https://chatbotdockervm.eastus.cloudapp.azure.com/chatbot_window?origin=awc"
            src="https://fourcolorstechexternalbot.eastus.cloudapp.azure.com/chatbot_window"
            style={{
              border: 'none',
            }}
            scrolling="no"
          />
        // </div>
      )}
    </div>
  );
};

export default Layout;